import { render } from "./SiderComponent.vue?vue&type=template&id=63200ad8&scoped=true"
import script from "./SiderComponent.vue?vue&type=script&lang=js"
export * from "./SiderComponent.vue?vue&type=script&lang=js"

import "./SiderComponent.vue?vue&type=style&index=0&id=63200ad8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63200ad8"]])

export default __exports__